import React from 'react';
import ReactFlow, {
    Background,
    Controls,
    MiniMap,
    useNodesState,
    useEdgesState
} from 'reactflow';
import 'reactflow/dist/style.css';
import { useTheme } from '../contexts/ThemeContext';

const ConceptMap = ({ nodes, edges }) => {
    const { theme } = useTheme();
    
    const [flowNodes, setNodes, onNodesChange] = useNodesState(
        nodes.map((node, index) => ({
            id: node.id,
            type: 'default',
            data: { label: node.label },
            position: {
                x: (index % 3) * 250 + 100,
                y: Math.floor(index / 3) * 150 + 100
            },
            style: {
                background: 'var(--primary)',
                color: 'var(--text)',
                border: '1px solid var(--border)',
                padding: '12px',
                borderRadius: '8px',
                width: 220,
                fontSize: '14px',
                fontWeight: '500',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                cursor: 'grab',
            }
        }))
    );

    const [flowEdges, setEdges, onEdgesChange] = useEdgesState(
        edges.map(edge => ({
            id: `${edge.from}-${edge.to}`,
            source: edge.from,
            target: edge.to,
            label: edge.relationship,
            type: 'smoothstep',
            animated: false,
            style: {
                stroke: 'var(--accent)',
                strokeWidth: 1.5,
            },
            labelStyle: {
                fill: 'var(--text)',
                fontSize: '12px',
                fontWeight: '500',
            },
            labelBgStyle: {
                fill: 'var(--secondary)',
            },
            labelBgPadding: [4, 2],
        }))
    );

    return (
        <div style={{
            width: '100%',
            height: 'calc(100vh - 200px)',
            borderRadius: '12px',
            background: 'var(--background)',
            overflow: 'hidden',
            border: '1px solid var(--border)',
        }}>
            <ReactFlow
                nodes={flowNodes}
                edges={flowEdges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                fitView
                attributionPosition="bottom-right"
                defaultViewport={{ zoom: 1.5 }}
                minZoom={0.2}
                maxZoom={4}
                nodesDraggable={true}
                nodesConnectable={false}
                elementsSelectable={true}
                style={{ background: 'var(--background)' }}
            >
                <Background
                    color="var(--accent)"
                    gap={16}
                    size={1}
                    style={{ opacity: 0.05 }}
                />

                <Controls
                    style={{
                        backgroundColor: 'var(--primary)',
                        border: '1px solid var(--border)',
                        borderRadius: '8px',
                        button: {
                            backgroundColor: 'var(--secondary)',
                            color: 'var(--text)',
                            border: '1px solid var(--border)',
                            '&:hover': {
                                backgroundColor: 'var(--primary-hover)',
                            },
                        },
                    }}
                />
            </ReactFlow>
        </div>
    );
};

export default ConceptMap;